<div class="academic-subject-picker">
  <button class="back-btn" (click)="goBack()" [attr.aria-label]="currLang === 'ar' ? 'رجوع' : 'Back'">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h2 class="picker-title">{{ currLang === 'ar' ? 'اختر المادة' : 'Pick a subject' }}</h2>

  <div class="subjects-grid">
    <button
      *ngFor="let subj of subjects"
      class="subject-card"
      type="button"
      [class.soon]="gameCount(subj.key) === 0"
      [style.--subject-color]="subj.color"
      (click)="selectSubject(subj.key)">
      <span class="subject-icon" [innerHTML]="subj.icon"></span>
      <span class="subject-name">{{ 'game-mode.subjects.' + subj.key | translate }}</span>
      <span class="game-tag" *ngIf="gameCount(subj.key) > 0">
        {{ gameCount(subj.key) | arabicNumber:currLang }} {{ currLang === 'ar' ? 'ألعاب' : 'games' }}
      </span>
      <span class="game-tag soon-tag" *ngIf="gameCount(subj.key) === 0">
        {{ currLang === 'ar' ? 'قريبًا' : 'soon' }}
      </span>
    </button>
  </div>
</div>
